import { render, staticRenderFns } from "./IcoChevronLeft.vue?vue&type=template&id=6d0d6517"
import script from "./IcoChevronLeft.vue?vue&type=script&lang=js"
export * from "./IcoChevronLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports